import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/select.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import PropsUtils from '../../packages/props-utils/props-utils.js';
import { InnerRefPropType } from '../../packages/props-utils/prop-types.js';
import SelectOption from './select-option/select-option.js';
import { requiredChildrenValidation } from '../../prop-types-validators/children-validator.js';
import { InputInfoChildren, InputInfo } from '../_atoms/input-info/input-info.js';
import { InlineLabel } from '../_atoms/inline-label/inline-label.js';
import '../_atoms/input-field/input-field.js';
import '../_atoms/nav-elem/nav-elem.js';
import { inputLabelValidator } from '../../prop-types-validators/input-label-validator.js';
import { iconValidator, handleIcon } from '../input/input-utils.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bem = new HoneyBem('select', styles);
function Select(_a) {
  var {
      active = false,
      disabled = false,
      multiple = false,
      extraClasses,
      id,
      label,
      valid,
      requiredText,
      icon,
      info,
      infoError,
      inlineLabel,
      innerRef,
      placeholder,
      children,
      required,
      'aria-describedby': ariaDescribedBy
    } = _a,
    rest = __rest(_a, ["active", "disabled", "multiple", "extraClasses", "id", "label", "valid", "requiredText", "icon", "info", "infoError", "inlineLabel", "innerRef", "placeholder", "children", "required", 'aria-describedby']);
  const describedByIds = PropsUtils.handleAriaDescribedBy(id, {
    inlineLabel,
    info,
    ariaDescribedBy
  });
  return /*#__PURE__*/React.createElement("div", {
    className: bem.b({
      valid: valid === true,
      error: valid === false,
      disabled,
      multiple,
      active,
      'no-label': !label
    }, extraClasses)
  }, label && PropsUtils.handleLabel({
    label,
    inputId: id,
    bem,
    requiredText
  }), /*#__PURE__*/React.createElement("div", {
    className: bem.e('container')
  }, inlineLabel && (/*#__PURE__*/React.createElement(InlineLabel, {
    id: id,
    className: bem.e('inline-label')
  }, inlineLabel)), icon && handleIcon(icon, bem.e('icon')), /*#__PURE__*/React.createElement("select", Object.assign({
    ref: innerRef,
    id: id,
    className: bem.e('field'),
    required: required,
    disabled: disabled,
    multiple: multiple,
    "aria-errormessage": "infoError-".concat(id),
    "aria-describedby": describedByIds
  }, valid === false && {
    'aria-invalid': true
  }, rest), placeholder && /*#__PURE__*/React.createElement(SelectOption, {
    value: "",
    placeholder: placeholder
  }), children)), /*#__PURE__*/React.createElement(InputInfo, {
    error: true,
    id: id,
    className: bem.e('info')
  }, infoError), info && (/*#__PURE__*/React.createElement(InputInfo, {
    id: id,
    className: bem.e('info')
  }, info)));
}
Select.displayName = 'Select';
Select.propTypes = {
  active: PropTypes.bool,
  extraClasses: PropTypes.string,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: inputLabelValidator('Select'),
  children(props) {
    const isSelectOptionErr = requiredChildrenValidation('SelectOption')(props, 'children', 'Select');
    const isSelectOptGroupErr = requiredChildrenValidation('SelectOptGroup')(props, 'children', 'Select');
    if (isSelectOptionErr === null || isSelectOptGroupErr === null) return null;
    return new Error('"Select" requires "children" of types "SelectOption" or "SelectOptGroup".');
  },
  requiredText: PropTypes.string,
  valid: PropTypes.bool,
  icon: iconValidator(),
  info: InputInfoChildren,
  infoError: InputInfoChildren,
  inlineLabel: PropTypes.node,
  innerRef: InnerRefPropType,
  placeholder: PropTypes.string
};
var Select$1 = Injecss(Select, styles);

export { Select, Select$1 as default };
